import './EditQuestionModal.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';

import { AI_TASK_STATUS } from '../../../components/Questions/commonComponents/Header/constants/constants';
import { QuestionAudioActions } from '../../../components/Questions/commonComponents/QuestionAudioActions/QuestionAudioActions';
import { QuestionExtraInformation } from '../../../components/Questions/commonComponents/QuestionDetails/componentes/QuestionExtraInformation';
import UploadInput from '../../../components/Questions/commonComponents/UploadInput/UploadInput';
import {
  getCharacterStatus,
  getTextCharacterCount,
  validateCharacterLimit,
} from '../../../utilities/characterCounter';
import {
  getAnswerContentErrorMessages,
  getDuplicateAnswers,
  getQuestionContentErrorMessages,
  getTextContentErrorMessages,
} from '../../../utilities/questionValidation';
import ContentIssues, {
  getAnswerIssuesField,
  getContentIssuesLabel,
} from '../../ContentIssues/ContentIssues';
import SpellCheckPreview from '../../SpellCheckPreview/SpellCheckPreview';
import Spinner from '../../Spinner/Spinner';
import WYSIWYG from '../../WYSIWYG/WYSIWYG';

class EditQuestionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      textareaValue: '',
      order: '',
      documentPage: '',
      softwarePage: '',
      presentationIndex: 0,
      substantialChangesQuestion: false,
      substantialChangesAnswer: false,
      isCreatingAiQuestion: this.props.isCreatingAiQuestion,
      customPrompt: '',
      addCustom: false,
      customText: '',
      userCustomPrompts: this.props.userCustomPrompts,
      value: false,
      errorCustom: false,
      customPromptSelect: '',
      createCustom: true,
      question: this.props.question,
      textInitial: this.props.question.text,
      loadSpinner: false,
      hasError: false,
      characterLimitError: false,
      updateEditorView: false,
      hasUnsavedImageDeletion: false,
    };
  }

  UNSAFE_componentWillMount() {
    const {
      item,
      isAnswer,
      isQuestion,
      multipleOption,
      question,
      isAIAdminFeedback,
    } = this.props;
    let initialState;
    if (isAnswer) {
      initialState = {
        textareaValue: item.text,
        order: item.order,
      };

      if (item.correct) {
        this.setState({ substantialChangesAnswer: item.substantialChanges });
      }
    }
    if (isQuestion) {
      initialState = {
        textareaValue: multipleOption ? item.text : item.flashQuestionText,
      };

      this.setState({
        substantialChangesQuestion: question.substantialChanges,
      });
    }
    if (isAIAdminFeedback) {
      initialState = {
        textareaValue: question.aiAdminFeedback || '',
      };
    }
    if (!isQuestion && !isAnswer && !isAIAdminFeedback) {
      initialState = {
        textareaValue: question.notes,
        documentPage: question.documentPage,
        softwarePage: question.softwarePage,
      };
    }
    initialState.presentationIndex = question.presentationIndex;
    this.setState(initialState);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isQuestion ||
      (this.props.isAnswer && this.props.item?.correct)
    ) {
      const modal = document.querySelector('.modal-content');
      if (this.state.isCreatingAiQuestion) {
        modal.classList.add('change-background');
      } else {
        modal.classList.remove('change-background');
      }

      if (
        (this.props.userCustomPrompts && !this.state.value) ||
        prevProps.question !== this.props.question
      ) {
        // Check for userCustomPrompts. If create, keep last prompt; if editquestion, keep the created custom.
        let customSelect = this.state.userCustomPrompts[0];
        let textCustom = this.state.customText;
        let addCustom = this.state.addCustom;
        let create = this.state.createCustom;
        if (this.props.question) {
          if (
            this.props.question.originalResponse &&
            !this.props.question.originalResponse.adminUser
          ) {
            this.setState({
              isCreatingAiQuestion: false,
            });
            this.props.setIsCreatingAiQuestion(false);
          }
          if (this.props.userCustomPrompts?.length) {
            this.props.userCustomPrompts.forEach((custom) => {
              if (this.props.question.originalResponse) {
                if (
                  custom.id === this.props.question.originalResponse.ai_prompt
                ) {
                  customSelect = custom;
                  textCustom = custom.prompt.replace('USER_PROMPT ', '');
                  addCustom = true;
                  create = false;
                }
              }
            });
          }
        }

        this.setState({
          value: true,
          customText: textCustom,
          customPromptSelect: customSelect,
          addCustom,
          createCustom: create,
        });
      }
    }
  }

  componentDidMount() {
    if (this.nameInput) this.nameInput.focus();

    if (this.props.question?.wasAIGenerated) {
      this.setState({ isCreatingAiQuestion: false });
      this.props.setIsCreatingAiQuestion(false);
    }
    // this.addEventListener();
  }

  optionIsSelected = (option) =>
    !!this.props.question.answers.find((answer) => answer.order === option);

  renderAnswerOptions = (answer) => {
    const { order } = this.state;
    return (
      <div>
        <select
          className="orderSelect BorderTextArea form-control"
          value={order}
          onChange={(event) => {
            const order = Number(event.target.value);
            this.setState({ order });
          }}
        >
          <option value={0}>Random</option>
          <option value={1} disabled={this.optionIsSelected(1)}>
            1
          </option>
          <option value={2} disabled={this.optionIsSelected(2)}>
            2
          </option>
          <option value={3} disabled={this.optionIsSelected(3)}>
            3
          </option>
          <option value={4} disabled={this.optionIsSelected(4)}>
            4
          </option>
        </select>
      </div>
    );
  };

  onClickFeedbackTemplate = (templateText) => {
    const current = this.state.textareaValue || '';
    const isEmpty =
      !current ||
      current === '<p><br></p>' ||
      current === '<p></p>' ||
      current.trim() === '';
    const newValue = isEmpty
      ? `<p>${templateText}</p>`
      : `${current}<p>${templateText}</p>`;

    this.setState({ textareaValue: newValue, updateEditorView: true }, () => {
      this.setState({ updateEditorView: false });
    });
  };

  getCurrentFieldErrors = () => {
    const { isQuestion, isAnswer, isFurtherReading, isAIAdminFeedback, item } =
      this.props;
    const question = this.props.question;

    if (isQuestion) {
      return getQuestionContentErrorMessages(this.state.textareaValue);
    }
    if (isAnswer) {
      const answers = (question.answers || []).map((answer) =>
        answer.id === item.id
          ? { ...answer, text: this.state.textareaValue }
          : answer,
      );
      const duplicateAnswers = getDuplicateAnswers(answers);
      const currentAnswer = answers.find((answer) => answer.id === item.id);
      return getAnswerContentErrorMessages(currentAnswer, duplicateAnswers);
    }
    if (isFurtherReading || isAIAdminFeedback) {
      return getTextContentErrorMessages(this.state.textareaValue);
    }
    return [];
  };

  getContentIssuesField = () => {
    const { isQuestion, isAnswer, isFurtherReading, isAIAdminFeedback, title } =
      this.props;

    if (isQuestion) return 'question';
    if (isAnswer) return getAnswerIssuesField(title);
    if (isFurtherReading) return 'further reading';
    if (isAIAdminFeedback) return 'AI feedback';
    return 'response';
  };

  renderContentErrorMessages = () => (
    <ContentIssues
      messages={this.getCurrentFieldErrors()}
      label={getContentIssuesLabel(this.getContentIssuesField())}
    />
  );

  renderAnswerArea = (item) => (
    <div className="editorAnswerWrapper">
      <WYSIWYG
        onChange={this.onChangeEditor}
        redBorder={this.state.redBorder}
        contentError={this.getCurrentFieldErrors().length > 0}
        height={400}
        value={this.state.textareaValue}
        updateEditorView={this.state.updateEditorView}
        focus
        modalSize
        showWarning={this.props.showWarning}
        allowedFormats={[
          ['bold', 'underline'],
          [{ script: 'sub' }, { script: 'super' }],
          ['formula'],
        ]}
      />
      {this.renderContentErrorMessages()}
    </div>
  );

  renderInput = (item, title) => {
    const { presentationIndex } = this.state;
    const valueInput = this.props.isPresentationIndex
      ? presentationIndex
      : title === 'Document page'
        ? this.state.documentPage
        : this.state.softwarePage;
    return (
      <div className="textAreaContainer">
        <textarea
          ref={(input) => {
            this.nameInput = input;
          }}
          onChange={(event) =>
            this.changePresentationIndexOrDocumentPage(
              event.target.value,
              title,
            )
          }
          name="text"
          type="text"
          value={valueInput}
          className={
            this.state.redBorder
              ? 'QuestionTextArea BorderTextArea form-control redBorder'
              : 'QuestionTextArea BorderTextArea form-control'
          }
        />
      </div>
    );
  };

  changePresentationIndexOrDocumentPage = (value, title) => {
    if (this.props.isPresentationIndex) {
      this.setState({ presentationIndex: value });
    } else if (title === 'Document page') {
      this.setState({ documentPage: value });
    } else if (title === 'Software page') {
      this.setState({ softwarePage: value });
    }
  };

  onChangeEditor = (value) => {
    this.setState({ textareaValue: value });
  };

  renderEditor = (item) => {
    if (this.props.isFurtherReading) {
      // Further Reading editor with character counter
      const { count, isValid } = getCharacterStatus(this.state.textareaValue);
      const isOverLimit = !isValid;
      return (
        <div className="editorWrapper">
          <div className="wysiwyg-further-reading-container">
            <WYSIWYG
              onChange={this.onChangeEditor}
              height={400}
              redBorder={this.state.redBorder}
              contentError={this.getCurrentFieldErrors().length > 0}
              value={this.state.textareaValue}
              updateEditorView={false}
              focus
              modalSize
              showWarning={this.props.showWarning}
            />
            {/* Character counter for Further Reading */}
            <div
              className={`character-counter ${isOverLimit ? 'over-limit' : ''}`}
            >
              <span>Characters: </span>
              <span className="character-counter-number">{count}</span>
              <span> / 1000</span>
            </div>
          </div>
          {/* Error message */}
          {this.state.characterLimitError && (
            <span className="redTextQuestion">
              Further Reading cannot exceed 1000 characters. Please reduce the
              content.
            </span>
          )}
          {this.renderContentErrorMessages()}
        </div>
      );
    }
    // Regular editor for Questions/Answers
    return (
      <div className="editorWrapper">
        <WYSIWYG
          onChange={this.onChangeEditor}
          height={400}
          redBorder={this.state.redBorder}
          contentError={this.getCurrentFieldErrors().length > 0}
          value={this.state.textareaValue}
          updateEditorView={false}
          focus
          modalSize
          showWarning={this.props.showWarning}
        />
        {this.state.redBorder && this.state.textareaValue.length === 0 && (
          <span className="redTextQuestion">
            You must fill in the question.
          </span>
        )}
        {this.state.redBorder &&
          getTextCharacterCount(this.state.textareaValue) > 1000 && (
            <span className="redTextQuestion">
              Question should not exceed 1000 characters.
            </span>
          )}
        {this.renderContentErrorMessages()}
      </div>
    );
  };

  validate = () => {
    const stateToSet = { redBorder: false };
    if (
      !this.props.isAnswer &&
      !this.state.textareaValue &&
      !this.props.isPresentationIndex &&
      !this.props.isFurtherReading &&
      this.props.title !== 'Document page' &&
      this.props.title !== 'Software page' &&
      !this.props.isAIAdminFeedback
    ) {
      stateToSet.redBorder = true;
      this.setState(stateToSet);
      return false;
    }
    if (!this.state.presentationIndex && this.props.isPresentationIndex) {
      stateToSet.redBorder = true;
      this.setState(stateToSet);
      return false;
    }

    // Only validate 1000 char limit for Questions/Answers, NOT for Further Reading
    if (
      !this.props.isFurtherReading &&
      getTextCharacterCount(this.state.textareaValue) > 1000
    ) {
      stateToSet.redBorder = true;
      this.setState(stateToSet);
      return false;
    }

    if (
      this.state.isCreatingAiQuestion &&
      !this.state.customText &&
      !this.state.customPromptSelect
    ) {
      this.setState({ errorCustom: true });
      return false;
    }
    this.setState(stateToSet);
    this.setState({ errorCustom: false });
    return true;
  };

  getQuestionUpdated = () => {
    const questionUpdated = this.props.question;
    if (this.props.multipleOption) {
      questionUpdated.text = this.state.textareaValue;
    } else {
      questionUpdated.flashQuestionText = this.state.textareaValue;
    }
    if (
      this.state.hasUnsavedImageDeletion ||
      this.state.question?.fileImageUrl
    ) {
      questionUpdated.fileImageUrl = this.state.question.fileImageUrl;
      questionUpdated.imageUrl = this.state.question.imageUrl;
    }
    return questionUpdated;
  };

  getPresentationIndexUpdated = () => ({
    chapter: this.props.question.chapter,
    id: this.props.question.id,
    presentationIndex: this.state.presentationIndex,
  });

  getNotesUpdated = () => {
    const questionUpdated = this.props.question;
    questionUpdated.documentPage = this.state.documentPage;
    questionUpdated.softwarePage = this.state.softwarePage;
    questionUpdated.notes = this.state.textareaValue;
    questionUpdated.flashQuestionNotes = this.state.textareaValue;
    return questionUpdated;
  };

  getAdminFeedbackUpdated = () => {
    const questionUpdated = this.props.question;
    questionUpdated.aiAdminFeedback = this.state.textareaValue;
    return questionUpdated;
  };

  countNotEmpty = (answers) => {
    const answersAux = answers.map((answer) => ({ ...answer }));
    let count = 0;

    const currentAnswerIndex = answersAux.findIndex(
      (a) => a.id === this.props.item.id,
    );
    if (currentAnswerIndex !== -1) {
      answersAux[currentAnswerIndex].text = this.state.textareaValue;
    }

    answersAux.forEach((a) => {
      if (a.text !== '' || a.imageUrl) count++;
    });
    return count;
  };

  submit = () => {
    if (
      this.props.isFurtherReading &&
      this.state.textareaValue &&
      !validateCharacterLimit(this.state.textareaValue)
    ) {
      this.setState({ characterLimitError: true });
      return; // Prevent saving
    }
    // Validate Questions/Answers (for other cases)
    if (
      !this.validate() &&
      getTextCharacterCount(this.state.textareaValue) > 1000
    ) {
      <span className="redTextQuestion">
        Question should not exceed 1000 characters.
      </span>;
      return;
    }
    let canSend = true;
    if (this.props.item.correct === true) {
      canSend =
        this.state.textareaValue !== '' ||
        this.state.question?.answers?.find((a) => a.correct)?.imageUrl;
    } else {
      const count = this.countNotEmpty(this.state.question?.answers);
      if (this.state.question?.answers.length >= 4 && count >= 2) {
        canSend = true;
      } else {
        canSend =
          this.state.textareaValue !== '' ||
          this.state.documentPage !== '' ||
          this.state.softwarePage !== '';
      }
    }

    if (this.props.isQuestion) {
      canSend = this.state.textareaValue || false;
    }

    let presentIndex = false;
    const pi = this.props.isPresentationIndex
      ? this.getPresentationIndexUpdated()
      : null;
    presentIndex = !!pi;

    if (
      canSend ||
      presentIndex ||
      this.props.isFurtherReading ||
      this.props.isAIAdminFeedback
    ) {
      // Reset error ONLY when actually going to save
      if (this.state.characterLimitError) {
        this.setState({ characterLimitError: false });
      }
      const questionUpdated = this.props.isAnswer
        ? this.prepareAnswerForSubmit()
        : this.props.isQuestion
          ? this.getQuestionUpdated()
          : this.props.isAIAdminFeedback
            ? this.getAdminFeedbackUpdated()
            : this.getNotesUpdated();
      this.setState({ hasError: false });
      questionUpdated.presentationIndex = pi
        ? pi.presentationIndex
        : questionUpdated.presentationIndex;
      if (questionUpdated.wasAIGenerated && this.props.isQuestion) {
        questionUpdated.substantialChanges =
          this.state.substantialChangesQuestion;
      }
      if (this.props.isAnswer) {
        if (questionUpdated.answers) {
          questionUpdated.answers.forEach((a) => {
            if (a && a.correct)
              if (
                this.props.item?.wasAIGenerated ||
                this.state.isCreatingAiQuestion
              ) {
                a.substantialChanges = this.state.substantialChangesAnswer;
              }
          });
        }
      }

      // if (questionUpdated.aiquestion) {
      //   questionUpdated.aiquestion = JSON.stringify(questionUpdated.aiquestion);
      // }

      questionUpdated.customPromptId =
        this.state.customPromptSelect?.id ?? this.state.customPromptSelect;

      questionUpdated.isCreatingAiQuestion = this.state.isCreatingAiQuestion;
      if (this.state.isCreatingAiQuestion) {
        questionUpdated.wasAIGenerated = true;
        const correctAns = questionUpdated.answers?.find((a) => a.correct);
        if (correctAns) correctAns.wasAIGenerated = true;
      }
      this.props.onSubmit(
        questionUpdated,
        this.props.assignment,
        this.props.isPresentationIndex,
      );
      this.props.closeModal();
    } else {
      this.setState({ hasError: true });
    }
  };

  prepareAnswerForSubmit = () => {
    const answer = this.state.question.answers.find(
      (a) => a.id === this.props.item.id,
    );
    const newAnswer = {
      ...answer,
      text: this.state.textareaValue,
      order: this.state.order,
    };

    const oldAnswer = this.props.question.answers.find(
      (answer) => answer.id === newAnswer.id,
    );
    let questionUpdated = this.props.question;
    if (oldAnswer && oldAnswer.order !== newAnswer.order) {
      questionUpdated = this.onChangeOrder(
        newAnswer.order,
        questionUpdated,
        oldAnswer.order,
        newAnswer.id,
      );
    }
    // get answ ers array position
    const answerIndex = questionUpdated.answers.findIndex(
      (answer) => answer.id === newAnswer.id,
    );
    questionUpdated[`fileImageUrlAnswer${answerIndex}`] = answer.fileImageUrl;

    questionUpdated.answers = questionUpdated.answers.map((answer) => {
      if (answer.id === newAnswer.id) return newAnswer;
      return answer;
    });

    if (!questionUpdated.id) questionUpdated.id = this.props.question.id;
    return questionUpdated;
  };

  renderButtons = () => (
    <div className="buttonsContainer">
      <Button
        className="btn btn-success"
        onClick={() => this.submit()}
        loading={this.props.loading}
      >
        Save
      </Button>
      <Button
        className="btn btn-secondary"
        onClick={() => this.props.closeModal()}
      >
        Cancel
      </Button>
      <span className="helper-text">Ctrl or cmd + enter to save</span>
    </div>
  );

  onChangeOrder = (newOrder, question, oldOrder, answerId) => {
    newOrder = Number(newOrder);
    if (newOrder !== 0 && oldOrder !== 0) {
      let increment = false;
      if (newOrder > oldOrder) {
        increment = true;
      }
      const answers = question.answers.map((answer) => {
        if (answer.id === answerId) answer.order = newOrder;
        return answer;
      });
      question.answers = answers.map((answer) => {
        if (
          increment &&
          answer.order <= newOrder &&
          answer.order > oldOrder &&
          answerId !== answer.id &&
          answer.order !== 0
        ) {
          answer.order -= 1;
        }
        if (
          !increment &&
          answer.order >= newOrder &&
          answer.order < oldOrder &&
          answer.id !== answerId &&
          answer.order !== 0
        ) {
          answer.order += 1;
        }
        return answer;
      });
    } else {
      question.answers = question.answers.map((answer) => {
        if (answer.id === answerId) {
          answer.order = newOrder;
        }
        return answer;
      });
    }
    return question;
  };

  renderFurtherReadingOptions = (item) => (
    <div className="pagesContainer">
      <label className="pageLabel">Display page:</label>
      <input
        min="0"
        type="text"
        className="pages pagesOne BorderTextArea"
        onChange={(e) => this.setState({ documentPage: e.target.value })}
        value={this.state.documentPage}
      />
      <label className="pageLabel">Software page:</label>
      <input
        min="0"
        type="number"
        className="pages BorderTextArea"
        onChange={(e) => this.setState({ softwarePage: e.target.value })}
        value={this.state.softwarePage}
      />
    </div>
  );

  onSelect = (event) => {
    let selectPrompt;
    const { userCustomPrompts } = this.state;
    const selectedIndex = userCustomPrompts.findIndex(
      (item) => item.prompt.replace('USER_PROMPT ', '') === event,
    );

    userCustomPrompts.forEach((item) => {
      if (item.prompt.replace('USER_PROMPT ', '') === event) {
        selectPrompt = item;
      }
    });

    // Here the selected item is moved to the first position
    if (selectedIndex > 0) {
      const selectedPrompt = userCustomPrompts.splice(selectedIndex, 1);
      userCustomPrompts.unshift(selectedPrompt[0]);
    }
    this.setState({
      customText: event,
      addCustom: !this.state.addCustom,
      customPromptSelect: selectPrompt,
      errorCustom: false,
      userCustomPrompts,
      createCustom: false,
    });
  };

  handleCreateUserCustomPrompt() {
    if (!this.state.customText) {
      this.setState({
        errorCustom: true,
      });
    } else {
      const { userCustomPrompts } = this.state;
      const newArray = [
        { prompt: this.state.customText },
        ...userCustomPrompts,
      ];
      this.setState({
        userCustomPrompts: newArray,
        customPromptSelect: this.state.customText,
        createCustom: false,
        addCustom: false,
      });
    }

    this.props.createUserCustomPrompt(
      this.state.customText,
      this.props.chapterId,
    );
  }

  handleChangeCustom() {
    if (!this.state.addCustom) {
      this.setState({ customText: '' });
    }
    this.setState({ addCustom: !this.state.addCustom });
  }

  handlePrompt(event) {
    let existPrompt = true;

    this.state.userCustomPrompts.forEach((item) => {
      if (item.prompt === event) {
        existPrompt = false;
      }
    });

    this.setState({ customText: event, createCustom: existPrompt });
  }

  showSuggestionValidation() {
    const question = this.props.question;
    if (!question?.text || !question?.aiSuggestion) {
      return false;
    }
    return true;
  }

  removeCharacters(text) {
    return text ? text.replace(/<\/?p>/g, '') : '';
  }

  render() {
    const {
      question,
      title,
      isAnswer,
      textarea,
      item,
      isQuestion,
      isAIAdminFeedback,
      isPresentationIndex,
      isEditingPage,
    } = this.props;

    const showAiSuggestionSection =
      this.state.loadSpinner ||
      question?.aiSuggestionStatus === AI_TASK_STATUS.IN_PROGRESS ||
      (!this.state.loadSpinner && this.showSuggestionValidation());

    const suggestionInProgress =
      question.aiSuggestionStatus === AI_TASK_STATUS.IN_PROGRESS;

    const isButtonDisabled =
      !question.id ||
      this.removeCharacters(this.state.textInitial).trim() !==
        this.removeCharacters(this.state.textareaValue).trim() ||
      suggestionInProgress;

    const hasAnyImage = Boolean(
      this.state.question?.imageUrl ||
      this.state.question?.answers?.some((answer) => answer?.imageUrl),
    );

    return (
      <div className="edit-question-modal">
        <div>
          {isQuestion && (
            <div>
              {
                /* item &&
                (!item.text ||
                  (item.originalResponse &&
                    item.originalResponse.adminUser)) && */ <div className="mt-3">
                  <span>
                    {
                      /* item && item.text */ item.originalResponse?.ai_question
                        ? 'Edit AI question'
                        : 'Create AI question'
                    }
                  </span>
                  <label
                    className="switch switch-3d switch-primary ml-2 mt-1"
                    style={{ width: 25, height: 15 }}
                  >
                    <input
                      type="checkbox"
                      className="switch-input"
                      checked={this.state.isCreatingAiQuestion}
                      onChange={() => {
                        this.props.setIsCreatingAiQuestion(
                          !this.state.isCreatingAiQuestion,
                        );
                        this.setState({
                          isCreatingAiQuestion:
                            !this.state.isCreatingAiQuestion,
                        });
                      }}
                    />
                    <span className="switch-label" />
                    <span
                      className="switch-handle"
                      style={{ height: 15, width: 15 }}
                    />
                  </label>
                </div>
              }
              <Row>
                <Col xs={3} md={5}>
                  <div className="editionTitle">{title}</div>
                </Col>
                <Col
                  xs={5}
                  md={7}
                  className="pb-1 pt-1"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                  }}
                >
                  {
                    /* In the grid view, only include the "improve question with AI" and 
                      "include further reading in ai suggestion" options when the question has already been created */
                    question.id && (
                      <>
                        <div
                          className={`more-options-btn  ${isButtonDisabled ? 'disabledButton' : 'suggestion-btn'}`}
                          onClick={() => {
                            if (!isButtonDisabled && question.text !== '') {
                              this.setState({ loadSpinner: true });
                              this.props.improveQuestionWithAi(
                                question.id,
                                question.chapter.id,
                              );
                              setTimeout(() => {
                                this.setState({ loadSpinner: false });
                              }, 300);
                            }
                          }}
                          title={
                            !isButtonDisabled
                              ? 'Improve question with AI'
                              : suggestionInProgress
                                ? 'Ai suggestion in progress'
                                : 'Unsaved changes'
                          }
                        >
                          <i className="fa fa-lightbulb-o" />
                        </div>
                        <div
                          title="Select to include further reading in the context of suggestion"
                          className="include-further-reading-checkbox"
                        >
                          <label style={{ fontSize: '0.8rem' }}>
                            <input
                              onClick={() => {
                                this.props.updateIncludeNotesInSuggestion(
                                  question.id,
                                  !question.includeNotesInSuggestion,
                                );
                              }}
                              type="checkbox"
                              checked={question.includeNotesInSuggestion}
                            />
                            Include further reading in ai suggestion
                          </label>
                        </div>
                      </>
                    )
                  }
                </Col>
              </Row>
            </div>
          )}
          {!isQuestion && <div className="editionTitle">{title}</div>}
          {isAnswer && item.correct && (
            <div className="mt-3">
              <span>
                {question.originalResponse?.ai_question
                  ? 'Edit AI question'
                  : 'Create AI question'}
              </span>
              <label
                className="switch switch-3d switch-primary ml-2 mt-1"
                style={{ width: 25, height: 15 }}
              >
                <input
                  type="checkbox"
                  className="switch-input"
                  checked={this.state.isCreatingAiQuestion}
                  onChange={() => {
                    this.props.setIsCreatingAiQuestion(
                      !this.state.isCreatingAiQuestion,
                    );
                    this.setState({
                      isCreatingAiQuestion: !this.state.isCreatingAiQuestion,
                    });
                  }}
                />
                <span className="switch-label" />
                <span
                  className="switch-handle"
                  style={{ height: 15, width: 15 }}
                />
              </label>
            </div>
          )}
          {isAnswer && this.renderAnswerOptions(item)}
          {!isAnswer &&
            !isQuestion &&
            !isAIAdminFeedback &&
            !isPresentationIndex &&
            !isEditingPage &&
            this.renderFurtherReadingOptions(item)}
        </div>
        {textarea &&
          !isPresentationIndex &&
          !isEditingPage &&
          this.renderAnswerArea(item)}
        {!textarea &&
          !isPresentationIndex &&
          !isEditingPage &&
          this.renderEditor(item)}
        {isPresentationIndex && this.renderInput(item)}
        {isEditingPage && this.renderInput(item, title)}
        {this.props.spellCheckEnabled &&
          !isPresentationIndex &&
          !isEditingPage && (
            <SpellCheckPreview value={this.state.textareaValue} showNoErrors />
          )}
        {this.state.hasError && (
          <p style={{ color: 'red' }}>
            {isQuestion
              ? "The question can't be deleted"
              : "The answer can't be deleted"}
          </p>
        )}
        {(isQuestion || (isAnswer && item.correct)) &&
          (this.state.isCreatingAiQuestion ||
            question.originalResponse?.ai_question ||
            question.originalResponse?.ai_answer) && (
            <Row className="substantialChangesCheckbox mb-2">
              <input
                type="checkbox"
                htmlFor="substantialChanges"
                value={
                  isQuestion
                    ? this.state.substantialChangesQuestion
                    : this.state.substantialChangesAnswer
                }
                onChange={(e) => {
                  if (isQuestion)
                    this.setState({
                      substantialChangesQuestion:
                        !this.state.substantialChangesQuestion,
                    });
                  if (isAnswer)
                    this.setState({
                      substantialChangesAnswer:
                        !this.state.substantialChangesAnswer,
                    });
                }}
                id={
                  isQuestion
                    ? 'substantialCheckboxQuestion'
                    : 'substantialCheckboxAnswer'
                }
                checked={
                  isQuestion
                    ? this.state.substantialChangesQuestion
                    : this.state.substantialChangesAnswer
                }
              />
              <label
                className="mb-0"
                htmlFor={
                  isQuestion
                    ? 'substantialCheckboxQuestion'
                    : 'substantialCheckboxAnswer'
                }
              >
                {`Substantial Changes Made to AI Generated ${
                  isQuestion ? 'Question' : 'Answer'
                }`}
              </label>
            </Row>
          )}

        {isQuestion && (
          <>
            {/* Ai suggestion  section */}
            {showAiSuggestionSection && (
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <QuestionExtraInformation
                  title="AI Suggestion"
                  backgroundColor="#f2d9f266"
                  headerColor="#ff80ff59"
                  body={
                    <>
                      {(this.state.loadSpinner ||
                        question?.aiSuggestionStatus ===
                          AI_TASK_STATUS.IN_PROGRESS) && (
                        <div>
                          <Spinner color="rgba(223,36,218,1)" />
                        </div>
                      )}
                      {!this.state.loadSpinner &&
                        this.showSuggestionValidation() &&
                        isQuestion && (
                          <>
                            <i className="fa fa-lightbulb-o" />
                            <span className="ml-2 text">
                              {question.aiSuggestion}
                            </span>
                          </>
                        )}
                    </>
                  }
                />
              </div>
            )}

            {/* Question Image  section */}
            {this.state.question &&
              (this.state.question?.imageUrl ||
                !this.state.question?.audio) && (
                <QuestionExtraInformation
                  title="Question Image"
                  backgroundColor="#e4ecf9"
                  headerColor="#afc8f0"
                  body={
                    <>
                      <div className="edit-question-grid-image">
                        <UploadInput
                          editPermission
                          imageUrl={this.state.question.imageUrl}
                          accept="image/x-png,image/gif,image/jpeg,image/jpg,image/webp"
                          chapter={{}}
                          deletePdfChapter={() => {
                            this.setState({
                              question: {
                                ...this.state.question,
                                imageUrl: null,
                                fileImageUrl: null,
                              },
                              hasUnsavedImageDeletion: true,
                            });
                          }}
                          updateQuestionPdfProcessing={() => {}}
                          questionPdfProcessing={false}
                          updateChapter={(chapter) => {
                            this.setState({
                              question: {
                                ...this.state.question,
                                fileImageUrl: chapter.pdf,
                                imageUrl: chapter.pdf.name,
                              },
                            });
                          }}
                          maxFileSize={500 * 1024} // 500KB limit for answer images
                          className="questionImageUrl"
                        />
                        {/* {question?.imageUrl?.includes('http') && (
                        <div className="ImageUrl">
                          <img
                            className="ImgLimit"
                            src={question.imageUrl}
                            alt="Question"
                          />
                        </div>
                      )} */}
                      </div>
                    </>
                  }
                />
              )}

            {/* Question Audio  section */}
            {this.state.question?.id &&
              !this.state.hasUnsavedImageDeletion &&
              (this.state.question?.audio || !hasAnyImage) && (
                <QuestionExtraInformation
                  title="Question Audio"
                  backgroundColor="#e4ecf9"
                  headerColor="#afc8f0"
                  body={<QuestionAudioActions question={question} />}
                />
              )}
          </>
        )}

        {isAnswer && (
          <div>
            {this.state.question &&
              (this.state.question?.imageUrl ||
                !this.state.question?.audio) && (
                <QuestionExtraInformation
                  title="Answer Image"
                  backgroundColor="#e4ecf9"
                  headerColor="#afc8f0"
                  body={
                    <>
                      <div className="edit-question-grid-image">
                        <UploadInput
                          editPermission
                          imageUrl={
                            this.state.question.answers.find(
                              (ans) => ans.id === item.id,
                            )?.imageUrl
                          }
                          accept="image/x-png,image/gif,image/jpeg,image/jpg,image/webp"
                          chapter={{}}
                          maxFileSize={500 * 1024} // 500KB limit for answer images
                          deletePdfChapter={(chapter) => {
                            const q = {
                              ...this.state.question,
                              answers: this.state.question.answers.map(
                                (answer) => {
                                  if (answer.id === item.id) {
                                    return {
                                      ...answer,
                                      imageUrl: null,
                                      fileImageUrl: null,
                                    };
                                  }
                                  return answer;
                                },
                              ),
                            };
                            this.setState({ question: q });
                          }}
                          updateQuestionPdfProcessing={() => {}}
                          questionPdfProcessing={false}
                          updateChapter={(chapter) => {
                            const q = {
                              ...this.state.question,
                              answers: this.state.question.answers.map(
                                (answer) => {
                                  if (answer.id === this.props.item.id) {
                                    return {
                                      ...answer,
                                      fileImageUrl: chapter.pdf,
                                      imageUrl: chapter.pdf.name,
                                    };
                                  }
                                  return answer;
                                },
                              ),
                            };
                            this.setState({ question: q });
                          }}
                          className="questionImageUrl"
                        />
                      </div>
                    </>
                  }
                />
              )}
          </div>
        )}

        {this.state.isCreatingAiQuestion &&
          (isQuestion || (isAnswer && item.correct)) && (
            <Col md={12} className="mt-3">
              <span>Custom Prompt</span>
              {this.state.errorCustom && (
                <span style={{ color: 'red' }} className="ml-1">
                  required
                </span>
              )}

              <div className="mt-3">
                <div>
                  {!this.state.addCustom ? (
                    <select
                      value={this.state.customPrompt}
                      className="form-control mb-2"
                      onChange={(e) => {
                        this.onSelect(e.target.value);
                      }}
                    >
                      {this.state.userCustomPrompts &&
                        this.state.userCustomPrompts.map((p) => (
                          <option value={p.prompt.replace('USER_PROMPT ', '')}>
                            {' '}
                            {p.prompt.replace('USER_PROMPT ', '').length > 70
                              ? `${p.prompt
                                  .replace('USER_PROMPT ', '')
                                  .substring(0, 70)}...`
                              : p.prompt.replace('USER_PROMPT ', '')}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <textarea
                        type="text"
                        value={this.state.customText}
                        disabled={false}
                        style={{
                          width: '100%',
                          border: this.state.errorCustom
                            ? '1px solid red'
                            : null,
                        }}
                        onChange={(e) => {
                          this.handlePrompt(e.target.value);
                        }}
                      />
                      {this.state.createCustom && (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <div className="check">
                            <i
                              className="fa fa-check fa-lg"
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                this.handleCreateUserCustomPrompt()
                              }
                            />
                          </div>
                          <div className="cross">
                            <i
                              className="fa fa-close fa-lg"
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                this.setState({
                                  addCustom: !this.state.addCustom,
                                })
                              }
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div>
                    <Button
                      className="btn btn-info mt-2 marginLeft"
                      onClick={() => this.handleChangeCustom()}
                    >
                      {' '}
                      {this.state.addCustom ? 'Select Custom' : 'Add Custom'}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          )}
        {isAIAdminFeedback && this.props.aiFeedbackTemplates?.length > 0 && (
          <div className="mt-2">
            <span className="editionTitle">Common AI Feedback</span>
            <div className="ai-feedback-templates-container">
              {this.props.aiFeedbackTemplates.map((template, index) => (
                <button
                  key={index}
                  type="button"
                  className="ai-feedback-pill"
                  onClick={() => this.onClickFeedbackTemplate(template)}
                >
                  {template}
                </button>
              ))}
            </div>
          </div>
        )}
        {this.renderButtons()}
      </div>
    );
  }
}

export default EditQuestionModal;
